import { addRecentSearch } from '@/components/helpers/recent-searches'

/**
 * Stores the current search query in the recentSearches cookie when on the search page.
 * Place once on the search template (e.g. in search-header section); no UI.
 */
export class RecentSearchesStoreElement extends HTMLElement {
  connectedCallback() {
    if (typeof window === 'undefined') return
    const pathname = window.location.pathname || ''
    if (!pathname.endsWith('/search')) return

    const params = new URLSearchParams(window.location.search)
    const query = (params.get('query') || params.get('q') || '').trim()
    if (query) addRecentSearch(query)
  }
}
